import * as actionTypes from '../actions/actionTypes';

export const setDepartId = (id, index) => {
    return {
        type: actionTypes.SET_DEPART_ID,
        val: id,
        index: index
    }
}

export const setReturnId = (id, index) => {
    return {
        type: actionTypes.SET_RETURN_ID,
        val: id,
        index: index
    }
}

export const setIntIds = (departId, returnId, tupleIndex) => {
    return {
        type: actionTypes.SET_INT_IDS,
        departId: departId,
        returnId: returnId,
        tupleIndex: tupleIndex
    }
}

export const clearFlights = () => {
    return {
        type: actionTypes.CLEAR_FLIGHTS
    }
}

export const toggleSidebar = () => {
    return {
        type: actionTypes.TOGGLE_SIDEBAR
    }
}

export const closeSidebar = () => {
    return {
        type: actionTypes.CLOSE_SIDEBAR
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/roundTripSummary.js